import { render, staticRenderFns } from "./NewOrEditTechnicianComponent.vue?vue&type=template&id=08ae4830&scoped=true&"
import script from "./NewOrEditTechnicianComponent.vue?vue&type=script&lang=js&"
export * from "./NewOrEditTechnicianComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewOrEditTechnicianComponent.vue?vue&type=style&index=0&id=08ae4830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ae4830",
  null
  
)

export default component.exports